import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { SubscriptionItemQuantityEventFormSchemaValues } from 'src/features/subscriptionItemQuantityEvents/utils/formSchema';
import { SubscriptionItemQuantityEvent } from 'src/features/subscriptionItemQuantityEvents/utils/types';

const RESOURCE = '/subscriptions/subscription-item-quantity-event/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionItemQuantityEventFormSchemaValues {
    subscription_item: string;
}

const mutationFn = (data: DTO): Promise<SubscriptionItemQuantityEvent> =>
    axios.post(formatResourcePath(RESOURCE), data);

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSubscriptionItemQuantityEvent };
